export enum ValueType {
	Currency = "Currency",
	Percentage = "Percentage",
	Number = "Number",
	String = "String",
	Boolean = "Boolean",
	Date = "Date",
	None = "None",
}
